// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3D2bB","buttons":"Footer_buttons__3pUa0"};